const parseRequestData = (data) => {
  if (!data) return undefined
  if (typeof data === "object") return data

  try {
    return JSON.parse(data)
  } catch {
    return undefined
  }
}

const accessCodeFromPath = (pathname) => {
  const match = pathname?.match(/^\/(?:sign|verify)\/([^/]+)/)
  if (!match) return undefined

  try {
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}

const accessCodeFromUrl = (url) => {
  if (typeof url !== "string" || !url.includes("?")) return undefined
  return new URLSearchParams(url.slice(url.indexOf("?") + 1)).get("signer-access-code") || undefined
}

export const closedSignerAccessRedirect = (error, pathname) => {
  if (error?.response?.status !== 410) return null

  const config = error.response.config || error.config || {}
  const data = parseRequestData(config.data)
  const signerAccessCode =
    config.params?.["signer-access-code"] ||
    data?.["signer-access-code"] ||
    accessCodeFromUrl(config.url) ||
    accessCodeFromPath(pathname)

  if (!signerAccessCode) return null

  const redirect = `/sign/${encodeURIComponent(signerAccessCode)}`
  const requestPath = typeof config.url === "string" ? config.url.split("?")[0] : ""
  const requestMethod = (config.method || "get").toLowerCase()
  const currentPath = pathname?.replace(/\/+$/, "") || "/"

  if (requestMethod === "get" && requestPath === "/sign" && currentPath === redirect) {
    return null
  }

  return redirect
}
